<template>
    <div class="card">
        <div class="card-body p-0">
            <cardHead :title="'Hotels Match'"></cardHead>
            <dataTable :name="'HotelsMatchList'" ref="agGrid" :columnDefs="columnDefs" :data="data" @cellClicked="goDetail"></dataTable>
        </div>
    </div>
</template>

<script>
    export default {
        props:{
            setModel:Object
        },
        data(){
            return{
                data:null,
                columnDefs:[
                    {"headerName":"Id","field":"Id","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                    {"headerName":"DestinationTownId","field":"DestinationTownId","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                    {"headerName":"DestinationTownName","field":"DestinationTownName","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                    {"headerName":"Star","field":"Star","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                    {"headerName":"Name","field":"Name","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                    {"headerName":"MatchCount","field":"MatchCount","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140}
                ]
            }
        },
        created(){
            this.$appAxiosAdmin.get(`Hotels/MatchList/`+this.$route.params.pathMatch[2]).then(response => {
            this.data=response.data;
            });
        },
        methods:{
            save(){
                this.$refs.form.validate().then(valid =>{
                    if(valid.valid){
                        this.process=true;
                        this.$appAxiosAdmin.put(`Softwares`,this.model).then(response => {
                            this.process=false;
                            this.$swal({
                                icon:"success",
                                title:"Success",
                                text:this.setModel!=undefined?"The software has been successfully updated.":"The software has been successfully added.",
                                timer: 2000,
                                confirmButtonText:"Okey"
                            });
                            if(this.setModel!=undefined){
                                this.$emit("update",response.data);
                            }else{
                                this.$emit("add",response.data);
                            }
                            this.$emit("close");
                        }).catch(err=>{
                            this.process=false;
                            this.$isError(err);
                        });
                    }
                });
            }
        }
    }
</script>

<style>

</style>